import type { PropsWithChildren } from 'react';

export function OnboardingContent({ children }: PropsWithChildren) {
  return children;
}
